import FullPageTile from 'deprecated/molecules/fullPageTile';
import React from 'react';
import Copy from './copy';
import { FullPageTileProps } from 'deprecated/molecules/fullPageTile/index.d';

const GDPR = ({ tileProps }: { tileProps?: FullPageTileProps }) => (
  <FullPageTile
    title={Copy.get('title')}
    description={Copy.get('header')}
    {...tileProps}
  >
    <p>{Copy.get('description')}</p>
    <ul>
      <li>{Copy.get('experian')}</li>
      <li>{Copy.get('firstData')}</li>
      <li>{Copy.get('masterCard')}</li>
      <li>{Copy.get('zipCodes')}</li>
    </ul>
  </FullPageTile>
);

export default GDPR;
